import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { spacing8 } from "@churchofjesuschrist/eden-style-constants";
import { Text5 } from "@churchofjesuschrist/eden-text";
const SecondaryMetaStyled = styled(Text5).withConfig({
  componentId: "sc-1p43n8x-0"
})(["display:inline-block;width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin:", " 0 ", ";position:absolute;padding:0 ", ";bottom:0;"], spacing8, spacing8, spacing8);

const SecondaryMeta = _ref => {
  let {
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(SecondaryMetaStyled, props, children);
};

SecondaryMeta.propTypes = {
  /** Secondary Meta Content */
  children: PropTypes.node.isRequired
};
export default SecondaryMeta;